import { isRegisteredUser } from 'redux/query';

export const hasSubscription = (state) => isRegisteredUser(state) && !!state.payment.userPaymentDetails.active;
